import './GameRecommendations.scss';

import React, { ReactElement, useContext } from 'react';
import CollapsiblePane from '../../shared/components/CollapsiblePane';
import GameRecommendationsNoResultsFoundMessage from './GameRecommendationsNoResultsFoundMessage';
import LoadingSpinner from '../../shared/components/LoadingSpinner';
import { ReactComponent as BooOutlineImage } from '../../../assets/boo-outline.svg';
import { SearchContext } from '../../contexts/SearchContext';
import { useGameRecommendations } from './useGameRecommendations';
import OutlineMessage from '../../shared/components/outline-messages/OutlineMessage';
import GameRecommendationEntry from './GameRecommendationEntry';

const GameRecommendations = (): ReactElement => {
    const searchContext = useContext(SearchContext);
    const resolvedNaid = searchContext?.resolvedNaid || '';
    const correlationId = searchContext?.correlationId || '';
    const { recommendations, loading, error } = useGameRecommendations(resolvedNaid, correlationId);

    const loadingSpinner: ReactElement = (
        <div className="p-3 text-center">
            <LoadingSpinner />
        </div>
    );

    return (
        <CollapsiblePane
            eventKey="GameRecommendations"
            headerText="Game Recommendations"
            disablePaneContentPadding
            dataCyForBody="game-recommendations"
        >
            {loading && loadingSpinner}
            {!loading && error && (
                <OutlineMessage
                    message="There are no Game Recommendations available at this time."
                    messageLocation="message-right"
                    outlineImage={<BooOutlineImage name="boo-outline-image" />}
                />
            )}
            {!loading && !error && recommendations.length === 0 && (
                <GameRecommendationsNoResultsFoundMessage />
            )}
            {!loading && !error && recommendations.length > 0 && (
                <div className="game-recommendations row no-gutters">
                    {recommendations.slice(0, 5).map((nsuid) => (
                        <GameRecommendationEntry key={nsuid} nsuid={nsuid} />
                    ))}
                </div>
            )}
        </CollapsiblePane>
    );
};

export default GameRecommendations;
